export const dynamicConfig = dynamicEnvironmentURLs => ({
  API: {
    ROOT_URL: () => dynamicEnvironmentURLs.apiBaseURL,
  },
});
